/* AuditEventList Messages
 *
 * This contains all the text for AuditEventList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.AuditEventList.header',
    defaultMessage: 'Audit events',
  },
  noAuditEventsYet: {
    id: 'app.components.AuditEventList.noAuditEventsYet',
    defaultMessage: 'There are no audit events, yet.',
  },
  noValue: {
    id: 'app.components.AuditEventList.noValue',
    defaultMessage: 'No value',
  },
  eventDetails: {
    id: 'app.components.AuditEventList.eventDetails',
    defaultMessage: 'Event details',
  },
  PasswordResetRequested: {
    id: 'app.components.AuditEventList.PasswordResetRequested',
    defaultMessage: 'Password reset requested',
  },
  PasswordReset: {
    id: 'app.components.AuditEventList.PasswordReset',
    defaultMessage: 'Password reset',
  },
  PublisherCreated: {
    id: 'app.components.AuditEventList.PublisherCreated',
    defaultMessage: 'Publisher created',
  },
  InvitationCreated: {
    id: 'app.components.AuditEventList.InvitationCreated',
    defaultMessage: 'Invitation created',
  },
  PublisherAccountChanged: {
    id: 'app.components.AuditEventList.PublisherAccountChanged',
    defaultMessage: 'Publisher account changed',
  },
  PublisherAccountDeactivated: {
    id: 'app.components.AuditEventList.PublisherAccountDeactivated',
    defaultMessage: 'Publisher account deactivated',
  },
  PublisherAccountLocked: {
    id: 'app.components.AuditEventList.PublisherAccountLocked',
    defaultMessage: 'Publisher account locked',
  },
  PublisherAcceptedInvitation: {
    id: 'app.components.AuditEventList.PublisherAcceptedInvitation',
    defaultMessage: 'Publisher accepted invitation',
  },
  PublisherCongregationChanged: {
    id: 'app.components.AuditEventList.PublisherCongregationChanged',
    defaultMessage: 'Publisher congregation changed',
  },
  PublisherConsentToErrorTrackingChanged: {
    id: 'app.components.AuditEventList.PublisherConsentToErrorTrackingChanged',
    defaultMessage: 'Publisher consent to error tracking changed',
  },
  PublisherConsentToJwPhoneChanged: {
    id: 'app.components.AuditEventList.PublisherConsentToJwPhoneChanged',
    defaultMessage: 'Publisher consent to JW.PHONE changed',
  },
  PublisherExperienceChanged: {
    id: 'app.components.AuditEventList.PublisherExperienceChanged',
    defaultMessage: 'Publisher experience changed',
  },
  PublisherLinkToPartnerChanged: {
    id: 'app.components.AuditEventList.PublisherLinkToPartnerChanged',
    defaultMessage: 'Publisher partner changed',
  },
  PublisherNameChanged: {
    id: 'app.components.AuditEventList.PublisherNameChanged',
    defaultMessage: 'Publisher name changed',
  },
  PublisherPrivilegeChanged: {
    id: 'app.components.AuditEventList.PublisherPrivilegeChanged',
    defaultMessage: 'Publisher privilege changed',
  },
  PioneerLevelChanged: {
    id: 'app.components.AuditEventList.PioneerLevelChanged',
    defaultMessage: 'Pioneer level changed',
  },
  PublisherPhoneChanged: {
    id: 'app.components.AuditEventList.PublisherPhoneChanged',
    defaultMessage: 'Publisher phone changed',
  },
});
